import { BaseDto } from "./base.dto"
import { FileDto } from "./file.dto"
import { TranslationDto } from "./translation.dto"

export class BeginnerGuideDto extends BaseDto {
  title: string
  titleKh: string
  description: string
  descriptionKh: string
  sortOrder: number
  enabled: boolean
  items: BeginnerGuideItemDto[]

  static create() {
    return new BeginnerGuideDto()
  }
}

export class BeginnerGuideItemDto extends BaseDto {
  title: string
  titleKh: string
  description: string
  descriptionKh: string
  enabled: boolean
  icon: FileDto
  button: TranslationDto
  link: string

  static create() {
    return new BeginnerGuideItemDto()
  }
}

export class UpdateBeginnerGuideItemDto {
  title?: string
  titleKh?: string
  description?: string
  descriptionKh?: string
  iconId?: string
  button?: any
  link?: string
}

export class CreateBeginnerGuideItemDto {
  title: string
  titleKh: string
  description: string
  descriptionKh: string
  iconId: string
  button: any
  link?: string
  beginnerGuideId: string
}

export class CreateBeginnerGuideDto {
  title: string
  titleKh: string
  description: string
  descriptionKh: string
}

export class UpdateBeginnerGuideDto {
  title?: string
  titleKh?: string
  description?: string
  descriptionKh?: string
}
